import {
  Box,
  FormControl,
  FormLabel,
  Text,
  Divider,
  SimpleGrid,
  RadioGroup,
  Radio,
  Checkbox,
  Stack,
  Select,
} from "@chakra-ui/core";
// import { Form } from 'formik';
import React, { useState } from "react";
import AddDynoInput from "../../../../../Components/Form/AddDynoInput";
import DynoInput from "../../../../../Components/Form/DynoInput";
import FormDatePicker from "../../../../../Components/Form/FormDatePicker";
import FormInput from "../../../../../Components/Form/FormInput";
import CardFooter from "../CardFooter";

const LandlineOptions = [
  {
    value: "91",
    label: "+91 (India)",
  },
  {
    value: "44",
    label: "+44 (UK)",
  },
  {
    value: "61",
    label: "+61 (Australia)",
  },
];

function PersonalInfo() {
  const [date, setDate] = useState(new Date(1995, 12, 1));

  return (
    <Box p="10">
      <Text fontSize="xl">Info</Text>
      <Divider marginBottom="1em" />
      <SimpleGrid marginY="2em" minChildWidth="120px" spacing="1em">
        <FormInput
          htmlFor="fName"
          label="First Name"
          helperText="Your First Name..."
        />
        <FormInput
          htmlFor="mName"
          label="Middle Name"
          helperText="Your Middle Name..."
        />
        <FormInput
          htmlFor="lName"
          label="Last Name"
          helperText="Your Last Name..."
        />
      </SimpleGrid>
      <SimpleGrid marginY="2em" minChildWidth="120px" spacing="1em">
        <FormControl>
          <FormLabel htmlFor="gender">Gender</FormLabel>
          <RadioGroup isInline>
            <Radio value="">Male</Radio>
            <Radio value="">Female</Radio>
          </RadioGroup>
        </FormControl>
        <FormControl gridColumn={{ lg: "2 /span 2" }}>
          <FormLabel htmlFor="maritalStatus">Marital Status</FormLabel>
          <RadioGroup isInline id="maritalStatus">
            <Radio value="">Single</Radio>
            <Radio value="">Married</Radio>
          </RadioGroup>
        </FormControl>
      </SimpleGrid>
      <FormControl marginY="2em">
        <FormLabel htmlFor="dob">DOB</FormLabel>
        <FormDatePicker setDate={setDate} date={date} />
      </FormControl>
      <Text fontSize="xl">Contact Details</Text>
      <Divider marginBottom="1em" />
      <SimpleGrid marginY="2em" minChildWidth="120px" spacing="1em">
        <FormInput
          htmlFor="permanentAdd"
          label="Permanent Address"
          placeholder="#123 Avenue, SM street"
        />
        <FormInput htmlFor="temporaryAdd" label="Temporary Address" />
      </SimpleGrid>
      <SimpleGrid marginY="2em" minChildWidth="120px" spacing="1em">
        <FormInput
          htmlFor="location"
          label="Location"
          placeholder="Bangalore"
        />
        <FormInput htmlFor="country" label="Country" placeholder="India" />
      </SimpleGrid>
      <SimpleGrid marginY="2em" minChildWidth="120px" spacing="1em">
        <DynoInput
          label="Landline"
          optionsArr={LandlineOptions}
          inputPH="9293024532"
          inputType="tel"
        />
        <DynoInput
          label="Mobile"
          optionsArr={LandlineOptions}
          inputPH="9293024532"
          inputType="tel"
        />
      </SimpleGrid>
      <SimpleGrid minChildWidth="120px" spacing="1em">
        <AddDynoInput />
      </SimpleGrid>
      <Text fontSize="xl">Salary Details</Text>
      <Divider marginBottom="1em" />
      <SimpleGrid marginY="2em" minChildWidth="150px" spacing="1em">
        <DynoInput
          label="Annual Salary"
          optionsArr={LandlineOptions}
          inputPH="9293024532"
          inputType="tel"
        />
        <DynoInput
          label="Expected Salary"
          optionsArr={LandlineOptions}
          inputPH="9293024532"
          inputType="tel"
        />
        <Stack marginX="0.2em">
          <Checkbox defaultIsChecked>Negotiable</Checkbox>
        </Stack>
      </SimpleGrid>
      <SimpleGrid marginY="2em" minChildWidth="120px" spacing="1em">
        <FormControl>
          <FormLabel>Notice Period</FormLabel>
          <Select>
            <option>3 Months</option>
            <option>6 Months</option>
            <option>12 Months</option>
          </Select>
        </FormControl>
        <FormControl>
          <FormLabel>Notice Period</FormLabel>
          <RadioGroup isInline>
            <Radio>Yes</Radio>
            <Radio>No</Radio>
          </RadioGroup>
        </FormControl>
        <FormControl>
          <FormLabel>How Long</FormLabel>
          <Select>
            <option>3 Months</option>
            <option>6 Months</option>
            <option>12 Months</option>
          </Select>
        </FormControl>
        <FormControl>
          <FormLabel>Already Serving</FormLabel>
          <RadioGroup isInline>
            <Radio>Yes</Radio>
            <Radio>No</Radio>
          </RadioGroup>
        </FormControl>
        <FormControl>
          <FormLabel>Last Day of Working</FormLabel>
          <FormDatePicker setDate={setDate} date={date} />
        </FormControl>
      </SimpleGrid>
      <CardFooter />
    </Box>
  );
}

export default PersonalInfo;
